import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultivendor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15 30C7.26801 30 1 23.732 1 16C1 8.26801 7.26801 2 15 2",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2C15 2 8 6 8 16C8 26 15 30 15 30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9999 10H2.3479",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9999 22H2.3479",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25 10C27.2091 10 29 8.20914 29 6C29 3.79086 27.2091 2 25 2C22.7909 2 21 3.79086 21 6C21 8.20914 22.7909 10 25 10Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.48 13.1281L25 18.0001L21.52 13.1281C19.941 14.2485 19.002 16.0639 19 18.0001V22.0001C19 23.1046 19.8954 24.0001 21 24.0001H22V28.0001C22 29.1046 22.8954 30.0001 24 30.0001H26C27.1046 30.0001 28 29.1046 28 28.0001V24.0001H29C30.1046 24.0001 31 23.1046 31 22.0001V18.0001C30.998 16.0639 30.059 14.2485 28.48 13.1281Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMultivendor);
export default ForwardRef;
